import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiServiceService } from './api-service.service';
import { Address } from '../interfaces/address.interface';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  constructor(private readonly apiService: ApiServiceService) {}

  getAddress(accountId: number): Observable<Address | null> {
    return this.apiService.get(`/address?accountId=${accountId}`);
  }

  getPatientAddress(
    accountId: number,
    patientId: number
  ): Observable<Address | null> {
    return this.apiService.get(
      `/address?accountId=${accountId}&patientId=${patientId}`
    );
  }

  saveAddress(address: Address): Observable<Address> {
    if (address.id && address.id > 0) {
      return this.apiService.put(`/address/${address.id}`, address);
    }
    return this.apiService.post(`/address`, address);
  }
}
